import {
  SCHEMES_ANALYTES_SUCCESS,
  SCHEMES_ANALYTES_FAIL,
  POST_RESULT_SUCCESS,
  POST_RESULT_FAIL,
  UPDATE_RESULT_SUCCESS,
  UPDATE_RESULT_FAIL,
  GET_RESULT_SUCCESS,
  GET_RESULT_FAIL,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_FAIL,
  POST_SERELOGY_VALUES_SUCCESS,
  POST_SERELOGY_VALUES_FAIL,
  GET_SERELOGY_VALUES_SUCCESS,
  GET_SERELOGY_VALUES_FAIL,
  GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS,
  GET_ANALYTE_RESULT_PARTICIPANT_FAIL,
  GET_MICRO_RESULT_DATA_SUCCESS,
  GET_MICRO_RESULT_DATA_FAIL,
  POST_MICRO_RESULT_SUCCESS,
  POST_MICRO_RESULT_FAIL,
  POST_MICRO_VALUE_SUCCESS,
  POST_MICRO_VALUE_FAIL,
  GET_MICRO_STATISTICS_SUCCESS,
  GET_MICRO_STATISTICS_FAIL,
  GET_MICRO_VALUE_LIST_SUCCESS,
  GET_MICRO_VALUE_LIST_FAIL,
  GET_ANALYTE_DATA_SUCCESS,
  GET_ANALYTE_DATA_FAIL,
  GET_RESULT_ANALYTE_DATA_SUCCESS,
  GET_RESULT_ANALYTE_DATA_FAIL,
  UPDATE_MICRO_RESULT_SUCCESS,
  UPDATE_MICRO_RESULT_FAIL,
  GET_QUALITATIVE_ASSIGN_SUCCESS,
  GET_QUALITATIVE_ASSIGN_FAIL,
  SAVE_STATISTICS_STATUS_SUCCESS,
  SAVE_STATISTICS_STATUS_FAILURE,
} from "./actionTypes";

const INIT_STATE = {
  SchemeAnalytesList: [],
  getAnalyteResultParticipant: [],
  PostResult: [],
  AnalyteData: [],
  PostMicroResult: [],
  UpdateMicroResult: [],
  updateResult: [],
  PostMicroValue: [],
  QualitativeAssign: [],
  updateMicroResult: [],
  MicroValueList: [],
  ResultAnalyteData: [],
  PostValues: [],
  ResultList: [],
  ValuesList: [],
  Statistics: [],
  schemeName: "",
  rounds: "",
  error: {},
  round_status: "",
  rounds_instance: "",
  scheme_id: "",
  schemeType: "",
  round_id: "",
  MicroResultList: {
    ListOrganism: [],
    ListAntibiotic: [],
    ReagentList: [],
    Instrument: [],
  },
};

const SchemeAnalytesList = (state = INIT_STATE, action) => {
  switch (action.type) {
    //get schemeAnalyte
    case SCHEMES_ANALYTES_SUCCESS:
      return {
        ...state,
        SchemeAnalytesList: action.payload.analytes || [],
        rounds: action.payload.round_no,
        round_id: action.payload.rounds, // ✅ just the id (integer)
        issue_date: action.payload.round_issuedate,
        closing_date: action.payload.round_closingdate,
        schemeName: action.payload.scheme_name,
        schemeType: action.payload.scheme_type,
        round_status: action.payload.round_status,
        result_type: action.payload.result_type,
        scheme_id: action.payload.scheme_id,
        cycle_no: action.payload.cycle_no,
        units: action.payload.units || [],
        methods: action.payload.methods || [],
        instruments: action.payload.instruments || [],
        reagents: action.payload.reagents || [],
        // 🔹 Add these for Identification scheme
        Statistics: action.payload.statistics || [], // organism-level
        AntibioticStatistics: action.payload.antibiotic_statistics || [], // organism+antibiotic-level
        IdentificationResults: action.payload.identification_results || [],
        sampleConditionCounts: action.payload.sample_condition_counts || {},
        sampleConditionLabs: action.payload.sample_condition_labs || {},
      };

    case SCHEMES_ANALYTES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SCHEMES_ANALYTES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    //post result
    case POST_RESULT_SUCCESS:
      return {
        ...state,
        PostResult: [...state.PostResult, action.payload.data],
      };

    case POST_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    ////////////////
    //UPDATE result

    case UPDATE_RESULT_SUCCESS:
      return {
        ...state,
        updateResult: [
          ...(state.updateResult || []),
          action.payload.data, // ✅ append new analyte update
        ],
      };

    case UPDATE_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    /////////////////////////////
    case POST_SERELOGY_VALUES_SUCCESS:
      return {
        ...state,
        PostValues: [...state.PostValues, action.payload.data],
      };

    case POST_SERELOGY_VALUES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    ////////////////////
    case GET_RESULT_SUCCESS:
      return {
        ...state,
        ResultList: action.payload.results,
        updated_at: action.payload.updated_at, // Store updated_at
      };

    case GET_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    /////////////////////////
    case GET_SERELOGY_VALUES_SUCCESS:
      return {
        ...state,
        ValuesList: action.payload,
      };
    case GET_SERELOGY_VALUES_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    ///////////////////////////////
    case GET_STATISTICS_SUCCESS:
      return {
        ...state,
        Statistics: action.payload,
      };
    case GET_STATISTICS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    ///////////////////////////////////
   case GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS:
  console.log(
    "GET_ANALYTE_RESULT_PARTICIPANT_SUCCESS action payload:",
    action.payload
  );
  return {
    ...state,
    getAnalyteResultParticipant: action.payload, // <-- remove .data
  };
    case GET_ANALYTE_RESULT_PARTICIPANT_FAIL:
      console.error(
        "GET_ANALYTE_RESULT_PARTICIPANT_FAIL error:",
        action.payload
      );

      return {
        ...state,
        error: action.payload,
      };
    case GET_MICRO_RESULT_DATA_SUCCESS:
      return {
        ...state,
        // Reset & update lists
        Instrument: action.payload.instruments || [],
        ReagentList: action.payload.reagents || [],
        ListOrganism: action.payload.organisms || [],
        ListAntibiotic: action.payload.antibiotics || [],
        ResultList: action.payload.results || [],
        MicroResultList: action.payload, // optional: store full payload if needed
        error: null,
      };

    case GET_MICRO_RESULT_DATA_FAIL:
      return {
        ...state,
        MicroResultList: null,
        ListOrganism: [],
        ListAntibiotic: [],
        ReagentList: [],
        Instrument: [],
        error: action.payload,
      };

    case POST_MICRO_RESULT_SUCCESS:
      return {
        ...state,
        PostMicroResult: [...state.PostMicroResult, action.payload.data],
      };

    case POST_MICRO_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_MICRO_VALUE_LIST_SUCCESS:
      return {
        ...state,
        MicroValueList: action.payload || [], // ✅ directly array
        error: null,
      };

    case GET_MICRO_VALUE_LIST_FAIL:
      return {
        ...state,
        MicroValueList: [],
        error: action.payload,
      };
    case POST_MICRO_VALUE_SUCCESS:
      return {
        ...state,
        PostMicroValue: [...state.PostMicroValue, action.payload.data],
      };

    case POST_MICRO_VALUE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_MICRO_STATISTICS_SUCCESS:
      console.log(
        "🟢 Reducer: GET_MICRO_STATISTICS_SUCCESS payload:",
        action.payload,
      );
      return {
        ...state,
        Statistics: action.payload,
        error: null,
      };

    case GET_MICRO_STATISTICS_FAIL:
      return {
        ...state,
        Statistics: null,
        error: action.payload,
      };

    case GET_ANALYTE_DATA_SUCCESS:
      console.log("reducer data", action.payload);
      return {
        ...state,
        AnalyteData:
          action.payload.data?.analytes || action.payload.analytes || [],
        schemeName:
          action.payload.data?.scheme_name || action.payload.scheme_name || "",
        schemeType:
          action.payload.data?.scheme_type || action.payload.scheme_type || "",
        rounds: action.payload.data?.round_no || action.payload.round_no || "",
        scheme_id:
          action.payload.data?.scheme_id || action.payload.scheme_id || null,
        round_status:
          action.payload.data?.round_status ||
          action.payload.round_status ||
          "",
        cycle_no:
          action.payload.data?.cycle_no || action.payload.cycle_no || "",
        issue_date:
          action.payload.data?.round_issuedate ||
          action.payload.round_issuedate ||
          "",
        closing_date:
          action.payload.data?.round_closingdate ||
          action.payload.round_closingdate ||
          "",
        units: action.payload.data?.units || action.payload.units || [],
        methods: action.payload.data?.methods || action.payload.methods || [],
        instruments:
          action.payload.data?.instruments || action.payload.instruments || [],
        reagents:
          action.payload.data?.reagents || action.payload.reagents || [],
      };

    case GET_ANALYTE_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_RESULT_ANALYTE_DATA_SUCCESS:
      console.log("🔥 Reducer updating ResultAnalyteData", action.payload);
      return {
        ...state,
        ResultAnalyteData: [
          ...(action.payload.data?.analytes || action.payload.analytes || []),
        ], // ✅ always new array
        schemeName:
          action.payload.data?.scheme_name || action.payload.scheme_name || "",
        schemeType:
          action.payload.data?.scheme_type || action.payload.scheme_type || "",
        rounds: action.payload.data?.round_no || action.payload.round_no || "",
        scheme_id:
          action.payload.data?.scheme_id || action.payload.scheme_id || null,
        round_status:
          action.payload.data?.round_status ||
          action.payload.round_status ||
          "",
        cycle_no:
          action.payload.data?.cycle_no || action.payload.cycle_no || "",
        issue_date:
          action.payload.data?.round_issuedate ||
          action.payload.round_issuedate ||
          "",
        closing_date:
          action.payload.data?.round_closingdate ||
          action.payload.round_closingdate ||
          "",
        units: [...(action.payload.data?.units || action.payload.units || [])], // ✅ new array
        methods: [
          ...(action.payload.data?.methods || action.payload.methods || []),
        ], // ✅ new array
        instruments: [
          ...(action.payload.data?.instruments ||
            action.payload.instruments ||
            []),
        ], // ✅ new array
        reagents: [
          ...(action.payload.data?.reagents || action.payload.reagents || []),
        ], // ✅ new array
      };

    case GET_RESULT_ANALYTE_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_MICRO_RESULT_SUCCESS:
      return {
        ...state,
        UpdateMicroResult: [...state.UpdateMicroResult, action.payload.data],
      };

    case UPDATE_MICRO_RESULT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_QUALITATIVE_ASSIGN_SUCCESS:
      return { ...state, loading: false, QualitativeAssign: action.payload };

    case GET_QUALITATIVE_ASSIGN_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SAVE_STATISTICS_STATUS_SUCCESS:
      return { ...state, loading: false, savedData: action.payload };
    case SAVE_STATISTICS_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default SchemeAnalytesList;
